import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, withProps } from 'recompose';
import { Button, Glyphicon } from 'react-bootstrap';


import omitProps from '../../../utils/omitProps';
import queryMetaHandler from '../../../utils/queryMetaHandler';

import linkWithCredentials from '../../../utils/linkWithCredentials';
import { getApiServerUrl } from '../../configuration/selectors';
import { downloadingFileAndUpdatingCredentials } from '../../../utils/downloadUpdatingCredentials';


const propTypes = exact({
  // eslint-disable-next-line react/no-unused-prop-types
  ticketId: PropTypes.number.isRequired,
  exportPath: PropTypes.string.isRequired,
  apiServerUrl: PropTypes.string.isRequired,
});


const TicketSubmissionItemDownloadButton = (props) => {
  const { exportPath, apiServerUrl } = props;

  const handleDownload = async () => {
    const pdfUrl = linkWithCredentials(`${apiServerUrl}${exportPath}`);
    downloadingFileAndUpdatingCredentials(pdfUrl);
  };

  return (
    <Button bsStyle="info" onClick={handleDownload}>
      <Glyphicon glyph="download-alt" style={{ marginRight: '0.5em' }} />
      Download Original Ticket
    </Button>
  );
};


TicketSubmissionItemDownloadButton.propTypes = propTypes;


const Query = gql`
  query TicketSubmissionItemUrl($ticketId: Int!) {
    ticket(ticket_id: $ticketId) {
      id
      ticket_number {
        id
        exportPath: export_path
      }
    }
  }
`;


const withData = graphql(Query);


const mapDataToProps = withProps((props) => {
  const {
    exportPath,
  } = props.data.ticket.ticket_number;

  return {
    exportPath,
  };
});


const mapStateToProps = (state) => {
  return {
    apiServerUrl: getApiServerUrl(state),
  };
};


const withRedux = connect(mapStateToProps, {});


const enhance = compose(
  withData,
  queryMetaHandler,
  mapDataToProps,
  withRedux,
  omitProps(['data']),
);


export default enhance(TicketSubmissionItemDownloadButton);
